import React, { createContext, useContext, useEffect, useState } from 'react'
import { AuthContext } from './AuthProvider'

export const DetailsContext = createContext()

const DetailsProvider = (props) => {
  const {user, isLogged, setIsLogged} = useContext(AuthContext)
  const [dashboardSummary, setDashboardSummary] = useState()
  const [recentComplain, setRecentComplain] = useState()
  const [recentUsers, setRecentUsers] = useState()
  const [users, setUsers] = useState()
  const [complaints, setComplaints] = useState()
  const [admins, setAdmins] = useState()
  const [banks, setBanks] = useState()
  const [countries, setCountries] = useState()
  const [transactions, setTransactions] = useState()
  const [verifications, setVerifications] = useState()
  const [costs, setCosts] = useState()
  const [adminUser, setAdminUser] = useState()

  const fetchData = async(data) => {
    if (user) {
      try {
        const response = await fetch('https://xgramm.com/xgramm_backend/admin/main.php', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        const result = await response.json()
        console.log(result)

        setDashboardSummary(result.dashSummary)
        setRecentComplain(result.dashSummary.recentComplain)
        setRecentUsers(result.dashSummary.recentUsers)
        setAdmins(result.admins)
        setBanks(result.banks)
        setCosts(result.costs)
        setCountries(result.countries)
        setTransactions(result.transactions)
        setUsers(result.users)
        setVerifications(result.verifications)
        setComplaints(result.Complains)
        setAdminUser(result.adminUser[0])
    } catch (error) {
        console.error("Error:", error)
    }
    }else{
      setIsLogged(false)
    }
    
}

  useEffect( () => {
    fetchData(user)
    }, [user])

  const value = {
    dashboardSummary,
    setDashboardSummary,
    recentComplain,
    setRecentComplain,
    user,
    recentUsers,
    setRecentUsers,
    users,
    admins,
    banks,
    costs,
    countries,
    transactions,
    verifications,
    fetchData,
    complaints,
    adminUser,
    setAdminUser
  }
  return (
    <DetailsContext.Provider value={value}>
      {props.children}
    </DetailsContext.Provider>
  )
}

export default DetailsProvider